<fhm-page [title]="'New Partner'" [showSave]="true"
          (doneClicked)="done()"
          (saveClicked)="save()"
          [description]="'New Sales Partner'">


    <fui-rows [formGroup]="formGroup">
        <fui-row>
            <fui-two-columns>

                <fui-column>

                    <fui-text-control formControlName="name"
                                      [control]="formGroup.get('name')"
                                      [label]="'Name'"
                                      [placeholder]="' '"
                                      [(ngModel)]="name"></fui-text-control>
                </fui-column>

            </fui-two-columns>

        </fui-row>

    </fui-rows>
</fhm-page>
